export function formatVnd(amount: number) {
  if (amount === null || amount === undefined) return '';

  const formatter = new Intl.NumberFormat('vi-VN', {
    style: 'currency',
    currency: 'VND'
  });
  return formatter.format(amount);
}